// extracted by mini-css-extract-plugin
export default {"badgeDish":"styles_badgeDish__xY0nP","badgeHalf":"styles_badgeHalf__1OZtl","badge":"styles_badge__i3xMr"};